if (!customElements.get('product-gallery')) {
  const chevron = `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 17 16" fill="none">
      <path d="M13.1667 5.99996L8.50008 10.6666L3.83341 5.99996" stroke="currentColor" stroke-width="0.75" stroke-linecap="square"/>
    </svg>`;
  
  class ProductGallery extends HTMLElement {
    constructor() {
      super();
    }

    swymInit() {
      const sparky_shuffle =  this.closest('sparky-shuffle');
      const option_radios = sparky_shuffle.querySelectorAll('[data-action="option-choice"]');
      const wishlist_icons = this.querySelectorAll('[data-wishlist-action');

      wishlist_icons.forEach(icon => {
        const wishlist_icon = icon.querySelector('svg');

        wishlist_icon.classList.remove('heart-icon-soft-red');
        wishlist_icon.classList.add('heart-icon-white');
      });

      setTimeout(() => {
        const variant_id = Number(sparky_shuffle.querySelector('[data-main-select]').value);
        const variant_is_on_wishlist = wishlist_items.find(item => item.epi === variant_id);

        // Uncomment below if we need to check for size selection.
        // let has_option_selected = false;
        // if (option_radios) has_option_selected = Array.from(option_radios).some(radio => radio.checked);

        // Add && has_option_selected in the conditional statement if size selection check needed.
        if (variant_is_on_wishlist) {
          wishlist_icons.forEach(icon => {
            const wishlist_icon = icon.querySelector('svg');

            wishlist_icon.classList.add('heart-icon-soft-red');
            wishlist_icon.classList.remove('heart-icon-white');
          });
        }
      }, 500);

      this.addEventListener('click', e => {
        const clickedElement = e.target.closest('[data-wishlist-action]');
        if (!clickedElement) return;

        const wishlist_icon = clickedElement.querySelector('svg');

        // Uncomment below to check for size selection before saving to wishlist.
        // const option_radios = sparky_shuffle.querySelectorAll('[data-action="option-choice"]');

        // if (option_radios) {
        //   const has_option_selected = Array.from(option_radios).some(radio => radio.checked);

        //   if (!has_option_selected) {
        //     swym_swat.ui.uiRef.showErrorNotification({message: 'Please select a size first.'})

        //     return;
        //   };
        // }

        const {
          wishlistProductId,
          wishlistVariantId,
        } = clickedElement.dataset;

        // Uncomment below to save specific size variants
        // const variant_id = sparky_shuffle.querySelector('[data-main-select]').value;

        // Modify the check to us the variant_id variable instead if saving size variants.
        const variant_is_on_wishlist = wishlist_items.find(item => item.epi === Number(wishlistVariantId));
        const product = {
          epi: wishlistVariantId,
          empi: wishlistProductId,
          du: window.location.href,
        }

        const addSuccess = () => {
          wishlist_icon.classList.add('heart-icon-soft-red');
          wishlist_icon.classList.remove('heart-icon-white');

          swym_swat.fetchLists({
            callbackFn: getListSuccess,
            errorFn: swymOnError,
          });
        }

        const removeSuccess = () => {
          wishlist_icon.classList.remove('heart-icon-soft-red');
          wishlist_icon.classList.add('heart-icon-white');

          swym_swat.fetchLists({
            callbackFn: getListSuccess,
            errorFn: swymOnError,
          });
        }

        const swymError = (error) => {
          console.error("Error while adding the Product to the List", error);
          alert(`Error while adding the Product to the List: ${error}`);
        }

        if (variant_is_on_wishlist) {
          swym_swat.deleteFromList(default_list_id, product, removeSuccess, swymError);
        } else {
          swym_swat.addToList(default_list_id, product, addSuccess, swymError);
        }
      });
    }
    
    connectedCallback() {
      poll(() => {
        return wishlist_items;
      }, 10000, 150).then(() => {
        this.swymInit();
      });
      
      const media_list = this.dataset.media.split(`,`);

      this.addEventListener('click', e => {
        const clickedElement = e.target.closest('[data-gallery-action]');
        if (!clickedElement) return;
        
        const {
          galleryAction: action,
          id,
          loader,
          mediaIndex,
        } = clickedElement.dataset;

        const media_index_number = Number(mediaIndex);
           
        switch (action) {
          case 'changeSlide':
            const fullImage = this.querySelector(`template[data-full-image="${id}"]`)?.cloneNode(true);
            const mainGallery = this.querySelector('[data-main-gallery]');
            const thumbnail = this.querySelector(`[data-id="${id}"]`);

            if (!fullImage || !mainGallery) return;
            const activeSlide = this.querySelector('[data-gallery-action="changeSlide"].active');
            activeSlide?.closest('[data-thumbnail-container]').setAttribute('aria-current', 'false');
            activeSlide?.classList.remove('active');
            
            this.style.setProperty('--main-loader-image', `url('${loader ? loader : media_list[mediaIndex]}')`);
            thumbnail.closest('[data-thumbnail-container]').setAttribute('aria-current', 'true');
            thumbnail.classList.add('active');
            thumbnail.scrollIntoView({
              behavior: `smooth`,
              block: `nearest`,
            });
            mainGallery.innerHTML = `
              <panzoom-element class="block h-full relative">
                ${media_list.length > 1 ? 
                  `<div class="hidden md:block absolute h-full w-full">
                    <button 
                      aria-label="Previous slide"
                      class="absolute z-10 top-1/2 pl-5" 
                      data-gallery-action="changeSlide" 
                      data-id="gallery-thumbnail-${media_index_number === 0 ? media_list.length : media_index_number}" 
                      data-media-index="${media_index_number === 0 ? media_list.length - 1 : media_index_number - 1}"
                    >
                      <div class="w-10 h-10 rotate-90">${chevron}</div>
                    </button>
                    <button 
                      aria-label="Next slide"
                      class="absolute z-10 top-1/2 right-0 pr-5" 
                      data-gallery-action="changeSlide" 
                      data-id="gallery-thumbnail-${media_index_number === media_list.length - 1 ? 1 : media_index_number + 2}" 
                      data-media-index="${media_index_number === media_list.length - 1 ? 0 : media_index_number + 1}"
                    >
                      <div class="w-10 h-10 -rotate-90">${chevron}</div>
                    </button>
                  </div>` : 
                  ``
                }
                ${fullImage.innerHTML}
              </panzoom-element>
            `;
          break;
          default:
          break;
        }
      });
    }
  }
  
  customElements.define('product-gallery', ProductGallery);
}